import { createContext } from "react";

export const HiddenFiltersContext =createContext({});